import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useQueryGetExamConfigForReport } from "@examspark/common-app";
import { Button, Loading, Toolbar, VSpace } from "@examspark/common-ui";

import ExamDetail from "../../activity/ExamDetail";

const ClassroomUnitActivity = () => {
  const navigate = useNavigate();
  const params = useParams<{
    activityId: string;
    unitId: string;
  }>();
  const { data: examConfig } = useQueryGetExamConfigForReport(
    params.activityId,
  );

  if (examConfig?.resource == null) {
    return <Loading />;
  }

  return (
    <VSpace size="3rem">
      <Toolbar>
        <Button
          title="Back to All Assessments"
          onClick={(e) => {
            navigate("../activities");
          }}
        >
          Back to All Assessments
        </Button>
      </Toolbar>
      <ExamDetail examId={examConfig.resource.id} />
    </VSpace>
  );
};

export default ClassroomUnitActivity;
